module.exports = __webpack_public_path__ + "static/media/default_over.0a731b8c.png";